import React from "react";
import { Link } from "react-router-dom";
import { formatFCFA, imageUrl, CLOTHING_TYPES, timeAgo } from "../../lib/format";
import { HeartButton } from "./HeartButton";

export default function ProductCard({ product, index = 0 }) {
  const isNew = (product.tags || []).includes("nouveau");
  const rupture = product.disponibilite === "Rupture";
  const typeLabel = (CLOTHING_TYPES.find((t) => t.value === product.type) || {}).label || product.type;
  return (
    <Link
      to={`/produit/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-[#E8D5CE] transition-all hover:-translate-y-1 hover:shadow-xl"
    >
      <div className="relative overflow-hidden bg-[#F5E8E3]">
        <img
          src={imageUrl(product.images && product.images[0], 640)}
          alt={product.nom}
          loading="lazy"
          decoding="async"
          className={`block h-auto w-full transition-transform duration-500 group-hover:scale-105 ${rupture ? "opacity-70" : ""}`}
        />
        {rupture ? (
          <span data-testid="card-rupture-badge" className="absolute left-2 top-2 max-w-[calc(100%-1rem)] truncate rounded-full bg-red-600/90 px-2.5 py-1 text-[10px] sm:left-3 sm:top-3 font-semibold uppercase tracking-wider text-white">
            {product.vendu_at ? `Vendu ${timeAgo(product.vendu_at)}` : "Vendu"}
          </span>
        ) : isNew ? (
          <span className="absolute left-3 top-3 rounded-full bg-[#D76E4D] px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-white">
            Nouveauté
          </span>
        ) : null}
        <span data-testid={`type-badge-${product.id}`} className="absolute bottom-3 left-3 rounded-full bg-white/85 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#2C1A14] backdrop-blur">
          {typeLabel}
        </span>
        <HeartButton product={product} className="absolute bottom-3 right-3" />
      </div>
      <div className="p-3 sm:p-4">
        <h3 className="truncate font-serif text-base text-[#2C1A14] sm:text-lg">{product.nom}</h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
          {product.taille && (
            <span data-testid={`taille-badge-${product.id}`} className="rounded-full bg-[#2C1A14] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-white">
              Taille {product.taille}
            </span>
          )}
          <span className="text-xs text-[#9B7E73]">{product.etat_client}</span>
        </div>
        <p className="mt-2 font-semibold text-[#D76E4D]">{formatFCFA(product.prix)}</p>
      </div>
    </Link>
  );
}
